<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.toast-header { justify-content:space-between !important;}
.toast:not(.show) {
    display: block !important;
}
.toast-body { background: #efefef !important;}
.toast-header button { border:1px solid #dfdfdf !important; background: #efefef;}
.modal-header button { border:1px solid #dfdfdf !important; background: #efefef;}
.custom-control-label { cursor: pointer !important;}
  .web-modal-foot {  width:100%; height:50px; flex-flow:row; justify-content:flex-end;  }
    .web-modal-foot a { width:100px; height:40px; line-height:40px; cursor: pointer; margin:10px 10px 0px 0px; padding:0px; color:#ffffff !important; text-align: center; border-radius: 4px; justify-content: center; background: #6c757d;}
    .web-modal-foot a:hover { color:#ffffff;}
    .web-modal-foot a.ok { background: #d81e06; color:#ffffff !important;}
    .web-modal-foot a.no { background: #6c757d; color:#ffffff !important;}
.custom-radio { margin-right:15px;}
.custom-control-input { margin-right:5px;}
.btn-block { width:100% !important;}
</style>



// WEBPACK FOOTER //
// src/App.vue